import { CallApi, handleJSONResponse } from './common';
import SimpleTrack from '@common/types/release/simple-track';
import { TrackOrderUpdate } from '@services/track/types/track-order-update';

const callAPI = CallApi('tracks');

export const create = async (track: Partial<SimpleTrack>): Promise<Partial<SimpleTrack>> =>
  await callAPI('/', 'POST', track)
    .then((response) => handleJSONResponse(response));

export const update = async (track: Partial<SimpleTrack>): Promise<Partial<SimpleTrack>> =>
  await callAPI('/', 'PUT', track)
    .then((response) => handleJSONResponse(response));


export const list = async (releaseId: string): Promise<Partial<SimpleTrack>[]> =>
  await callAPI(`/${releaseId}`, 'GET')
    .then((response) => handleJSONResponse(response));

export const listMultiple = async (releaseIds: string[]): Promise<Partial<SimpleTrack>[]> =>
  await callAPI('/', 'GET', { releaseIds })
    .then((response) => handleJSONResponse(response));

export const updateOrder = async (releaseId: string, order: TrackOrderUpdate[]): Promise<any> =>
  await callAPI(`/${ releaseId }`, 'PUT', order)
    .then((response) => handleJSONResponse(response));

export const deleteTrack = async (releaseId: string, trackId: string): Promise<any> =>
  await callAPI(`/${releaseId}/${trackId}`, 'DELETE')
    .then((response) => handleJSONResponse(response));
